import Grid from "@Components/Grid";
import BackButton from "@Components/BackButton";
import Paper from "@Components/Paper";
import { UserForm } from "./UserForm";
import { CreateUserRequest } from "@Types/users";
import { useCreateMember } from "@Hooks/useUsers";

import styles from "./User.module.scss";
import useCurrentUser from "@Hooks/useCurrentUser";
import mixpanel from "mixpanel-browser";

const User = () => {
  const user = useCurrentUser();
  const { createUser } = useCreateMember();

  const handleSaveChanges = (
    e: React.FormEvent<HTMLFormElement>,
    state: CreateUserRequest | undefined
  ) => {
    e.preventDefault();
    if (state) {
      createUser(state);
      mixpanel.track("New lender user created", {
        email: user?.data?.info?.email,
        lenderName: user?.data?.lender?.data?.info?.name,
        newMemberEmail: state?.data?.info?.email,
        newMemberNames: [
          state?.data?.info?.firstName,
          state?.data?.info?.lastName,
        ]
          ?.filter((x) => x)
          .join(" "),
      });
    }
  };
  return (
    <Grid container xs={12} spacing={1} className={styles.container}>
      <Grid container xs={12}>
        <Grid xs={1}>
          <BackButton />
        </Grid>
        <Grid xs={12}>
          <Paper title="New User">
            <UserForm<CreateUserRequest>
              id="create-user"
              type="create"
              initialState={{
                data: {
                  info: {
                    firstName: "",
                    lastName: "",
                    email: "",
                  },
                },
              }}
              handleSubmit={handleSaveChanges}
            />
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default User;
